import { Form, Modal } from "antd";
import React from "react";
import { CreateWaterPointPollutantDto } from "../../../api";
import { waterPointPollutantsColumns } from "../form/columns";

interface WaterPointPollutantFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWaterPointPollutant: (values: CreateWaterPointPollutantDto) => void;
}

export const WaterPointPollutantForm: React.FC<WaterPointPollutantFormProps> = ({ visible, setVisible, onCreateWaterPointPollutant }) => {
  const [form] = Form.useForm<CreateWaterPointPollutantDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWaterPointPollutant}>
        {waterPointPollutantsColumns.map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
            {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
